import type { CSSProperties, InputHTMLAttributes } from "react";

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  label?: string;
  error?: string;
  /** RN-convention change handler — receives the string value directly. */
  onChangeText?: (value: string) => void;
  className?: string;
  style?: CSSProperties;
}

export default function Input({
  label,
  error,
  onChangeText,
  id,
  className = "",
  style,
  ...rest
}: InputProps) {
  const inputId = id ?? (label ? `input-${label.replace(/\s+/g, "-").toLowerCase()}` : undefined);
  const errorId = error && inputId ? `${inputId}-error` : undefined;
  return (
    <div>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-[13px] font-semibold mb-2"
          style={{ color: "var(--ish-dark)" }}
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
        onChange={(e) => onChangeText?.(e.target.value)}
        className={
          "input-sacred w-full rounded-lg px-4 py-3 text-[14px] " +
          (error ? "border-[var(--color-error)] " : "") +
          className
        }
        style={{ color: "var(--ish-dark)", ...style }}
        {...rest}
      />
      {error && (
        <p
          id={errorId}
          role="alert"
          className="mt-1 text-[12px]"
          style={{ color: "var(--color-error)" }}
        >
          {error}
        </p>
      )}
    </div>
  );
}
